<template>
  <div class="overlay">
    <div class="load">
      <img :src="logo" alt="Cargando" class="center-block">
    </div>
  </div>
</template>

<script lang="js">
import logo from '@/assets/loader.gif'

export default {
  name: 'overlay',
  props: [],
  mounted () {},
  data () {
    return {
      logo
    }
  },
  methods: {},
  computed: {}
}
</script>

<style scoped lang="scss">
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: linear-gradient(
    -45deg,
    rgba(88, 47, 50, 0.8) 0%,
    rgba(68, 47, 74, 0.95) 100%
  );
  & > .load {
    position: absolute;
    top: 40%;
    left: 40%;
    color: aliceblue !important;
    text-align: center;
    img {
      margin: auto 0;
    }
  }
}
</style>
